import { render } from "./LabelDetail.vue?vue&type=template&id=791b8918"
import script from "./LabelDetail.vue?vue&type=script&lang=js"
export * from "./LabelDetail.vue?vue&type=script&lang=js"

import "./LabelDetail.vue?vue&type=style&index=0&id=791b8918&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__